import React from 'react'
import './About.css'
import AboutHero from './AboutHero'
import AboutSection1 from './AboutSection1'
import AboutSection2 from './AboutSection2'

function About() {
  return (
    <div>
        <AboutHero/>
        <AboutSection1/>
        <AboutSection2/>
    </div>
  )
}

export default About